var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":"size"}},[_c('div',{class:[
      _vm.avatarClass,
      'tw-flex tw-flex-row tw-items-center tw-justify-center'
    ],style:(_vm.avatarColor)},[_c('span',{staticClass:"tw-text-white",class:_vm.textClass},[_vm._v(_vm._s(_vm.user.initials))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }